import { Redirect, Route, Switch } from "wouter";
import {
  ClarityWebsiteAboutPage,
  ClarityWebsiteExperiencePage,
  ClarityWebsiteHogrPage,
  ClarityWebsiteHogrChapterPage,
  ClarityWebsiteBuildMyHomePage,
  ClarityWebsiteHomePage,
  ClarityWebsiteSuperlativePage,
  ClarityWebsiteSuperlativeBrandPage,
  ClarityWebsiteSuperlativeProductPage,
} from "@/app/lazyRoutes";

/**
 * SPA routes when served on www.claritygroup.com.sg — the public Clarity
 * website. Same pages as the /sandbox/clarity-website module; only the base
 * path differs (resolved by clarityWebsiteBasePath()). Activating this is a
 * DNS / hostname change, not a code restructure.
 */
export default function ClarityWebsiteDomainRouter() {
  return (
    <Switch>
      <Route path="/superlative-audio-systems/brands/:brand" component={ClarityWebsiteSuperlativeBrandPage} />
      <Route path="/superlative-audio-systems/products/:slug" component={ClarityWebsiteSuperlativeProductPage} />
      <Route path="/superlative-audio-systems" component={ClarityWebsiteSuperlativePage} />
      <Route path="/about" component={ClarityWebsiteAboutPage} />
      <Route path="/build-a-project/my-home" component={ClarityWebsiteBuildMyHomePage} />
      <Route path="/build-a-project/:chapter" component={ClarityWebsiteHogrChapterPage} />
      <Route path="/build-a-project" component={ClarityWebsiteHogrPage} />
      <Route path="/experiences/:slug" component={ClarityWebsiteExperiencePage} />
      <Route path="/" component={ClarityWebsiteHomePage} />
      <Route>
        <Redirect to="/" />
      </Route>
    </Switch>
  );
}
